
import { useRoute, useRouter } from "vue-router/composables";
import { GoogletagSupport } from "@components/ads/googletags-support";
import CiBreadcrumbs from "@components/base/breadcrumbs.vue";
import { computed, defineComponent, inject, onBeforeUnmount, onMounted, Ref, ref } from "vue";
import CompileHtml from "@components/base/CompileHtml.vue";
import { InfogramComposable } from "@composables/infogram-composable";
import { ROUTENAMES } from "@models/constants/routes";
import { SharingNetworks } from "@models/enums";
import { settingsService } from "@services/settings.service";

export default defineComponent({
  name: "CiContentHub",
  components: {
    CompileHtml,
    CiBreadcrumbs,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    // Tags methods
    const tagNames: any = inject("tagNames", []);
    const breadCrumbs: ContentHubs.BreadCrumb[] = inject("breadCrumbs", []);

    const lastTag = computed((): string => tagNames.value[tagNames.value.length - 1]);

    const shareTrackingTarget = computed(() => ({
      name: "ContentHub",
      identifier: contentRoute?.value?.id?.toString() || "",
    }));
    const sharingNetworks = [
      SharingNetworks.CustomEmail,
      SharingNetworks.CustomMessaging,
      SharingNetworks.LinkedIn,
      SharingNetworks.Twitter,
      SharingNetworks.Facebook,
    ];

    // Content Hub methods
    const contentRoute: Ref<Nullable<ContentHubs.ContentRoute>> = inject("contentRoute", ref(null));
    const contentHub = computed(
      (): ContentHubs.ContentHub | Record<string, string> => contentRoute.value?.content_hub || {}
    );
    const copyright = computed((): any => contentHub.value?.copyright || {});
    const id = computed((): number => contentRoute.value?.id || -1);
    const sharingUrl = computed(
      (): string =>
        location.origin +
        router.resolve({ name: ROUTENAMES.CONTENT_HUBS_SHOW, params: { pathMatch: contentRoute?.value?.slug || "" } })
          .href
    );
    onMounted(async () => {
      InfogramComposable.loadInfogram();
      InfogramComposable.infogramWatchConsent();
      if (settingsService.hasFlipper("page_ads")) {
        GoogletagSupport.initInlineAds(route?.meta?.ads);
      }
    });

    onBeforeUnmount(async () => {
      InfogramComposable.infogramUnwatchConsent();
    });

    return {
      tagNames,
      lastTag,
      contentRoute,
      contentHub,
      copyright,
      id,
      breadCrumbs,
      sharingNetworks,
      sharingUrl,
      shareTrackingTarget,
    };
  },
});
